import { CAS } from '../../CIMSModule/instances'
import { CIMSPageItem } from '../CIMSPageItem'
import { DispositionTypes, Notifications, QuickLinks, Types } from '.'

export const CASTracker = new CIMSPageItem({
  id: 'b4870ef3-d23c-43b8-b0ec-052c2cfb151f',
  name: 'Submittal Tracker',
  pathname: 'tracker',
  module: CAS,
  linkable: true,
})
export const CASRoutingGroups = new CIMSPageItem({
  id: 'b7c7696f-83eb-408a-9882-ca4ff094254c',
  name: 'Routing Groups',
  pathname: 'routing-groups',
  module: CAS,
})
export const CASTypes = Types({
  id: '4c8a9fe6-a546-4c14-a9f0-550c1ffcaf0c',
  module: CAS,
})
export const CASSubtypes = new CIMSPageItem({
  id: '22dc900f-af2c-4371-be82-9b89f07f7fe3',
  name: 'Subtypes',
  pathname: 'subtypes',
  module: CAS,
})
export const CASQuickLinks = QuickLinks({
  id: '4a2b8c7d-66f6-4b28-be84-97a387abe71a',
  module: CAS,
})
export const CASNotifications = Notifications({
  id: '7f7263fc-f3bb-438c-823d-31e7463863a0',
  module: CAS,
})
export const CASDispositionTypes = DispositionTypes({
  id: 'e08acc50-910e-4861-b0f1-fcbd2dafcf79',
  module: CAS,
})
export type CASPageItem =
  | typeof CASTracker
  | typeof CASRoutingGroups
  | typeof CASTypes
  | typeof CASSubtypes
  | typeof CASQuickLinks
  | typeof CASNotifications
  | typeof CASDispositionTypes
